import { render, staticRenderFns } from "./ModifyContact.vue?vue&type=template&id=0ac6b05c"
import script from "./ModifyContact.vue?vue&type=script&lang=js"
export * from "./ModifyContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports